import React from "react"
import type { CustomFieldBoolean } from "@love-irish/types"
import { Badge } from "@love-irish/ui-components"

const BooleanField = ({ field }: { field: CustomFieldBoolean }) => {
  const displayValue = field.value ? "Yes" : "No"

  return (
    <Badge variant="outline">
      <strong className="mr-1">{field.label}:</strong> {displayValue}
    </Badge>
  )
}

export default BooleanField
